import { QueryClient } from '@tanstack/react-query'
import { getBarcodeDoc } from '@/services/firebaseApi'
import { barcodeQueryKey, normalizeBarcode } from '@/utils/barcode'
import { BarcodeRead } from '@/types'

export const fetchBarcodeMapping = (
    queryClient: QueryClient,
    storageId: string,
    barcode: string,
): Promise<BarcodeRead | null> => {
    const normalized = normalizeBarcode(barcode)
    if (!storageId || !normalized) return Promise.resolve(null)
    return queryClient.fetchQuery({
        queryKey: barcodeQueryKey(storageId, normalized),
        queryFn: () => getBarcodeDoc({ storageId, barcode: normalized }),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    })
}
